export default {
  recordDate: '',
  grouping: 1,
  hasCamera: true,
  hasPlanting: false,
  imgSize: '1'
}
